/**
 * DesktopState: contains all global information / config pertaining to
 * the desktop instantiation (if applicable) of the Vault web app
 * */

declare global {
  interface Window {
    // if .vaultSystem is defined on the window object, we are in an electron environment
    vaultSystem: object | undefined;
  }
}

export class DesktopState {
  public get isDesktop(): boolean {
    return window.vaultSystem !== undefined;
  }
}

// singleton pattern - there is only one desktop state per client
const desktopState = new DesktopState();

export { desktopState };
